import React, { useCallback, useMemo } from 'react';
import moment, { Moment } from 'moment';
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import './style.scss';

export interface IWeekdaysSelectorProps {
    onDateChange?: (date: Date) => void;
    className?: string;
}

const WeekdaysSelector: React.FC<IWeekdaysSelectorProps> = ({
    onDateChange,
    className = ''
}) => {
    // const currentSelectedDate = selectedDate ? moment(selectedDate) : moment();

    // Generate 7 days starting from Monday of the week containing the selected date
    const weekdays = useMemo(() => {
        const timeZoneId = AdminService.getVenueTimezoneId();
        const today = moment(DateUtilsService.getVenueTime(timeZoneId));

        // Get Monday of the week containing the selected date
        const startOfWeek = today.clone().startOf('isoWeek');

        const days = [];
        // Generate 7 days from Monday to Sunday
        for (let i = 0; i < 7; i++) {
            const day = startOfWeek.clone().add(i, 'days');
            const isToday = day.isSame(today, 'day');

            days.push({
                date: day.toDate(),
                label: isToday ? 'Today' : day.format('ddd'),
                dayNumber: day.format('D'),
                momentObj: day,
                isToday,
            });
        }

        return days;
    }, []);

    const handleDayClick = useCallback((date: Date) => {
        if (onDateChange) {
            onDateChange(date);
        }
    }, [onDateChange]);

    return (
        <div className={`weekdays-selector ${className}`}>
            {weekdays.map((day, index) => (
                <button
                    key={index}
                    className={`weekday-button ${day.isToday ? 'today' : ''}`}
                    onClick={() => handleDayClick(day.date)}
                    type="button"
                >
                    <span className="weekday-label">{day.label}</span>
                </button>
            ))}
        </div>
    );
};

export default WeekdaysSelector;
